import { request } from '@/common/services/request';

export async function querySkills() {
  const result = await request('/api/admin/skills', {
    method: 'GET',
  });
  const data = result.data || [];
  return {
    data,
    success: true,
    total: data.length,
  };
}

export async function updateSkillRegistry() {
  return request('/api/admin/skills/registry', {
    method: 'POST',
  });
}
